export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="border-t hairline px-6 md:px-10 lg:px-14 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3"
      data-testid="footer"
    >
      <p className="label">© {year} Akanksha Chandok — Hypmmedia</p>
      <p className="label">
        Designed &amp; built with intention · <span className="text-crimson">·</span>
      </p>
    </footer>
  );
};

export default Footer;
